import { AnimatePresence, motion } from "framer-motion";
import { X, UtensilsCrossed, Wheat } from "lucide-react";
import { BREADS } from "@/data/site";

export const SandwichDrawer = ({ item, onClose }) => (
  <AnimatePresence>
    {item && (
      <>
        <motion.div
          data-testid="drawer-backdrop"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[60] bg-ink/50 backdrop-blur-sm"
        />
        <motion.aside
          data-testid="sandwich-detail-drawer"
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed right-0 top-0 z-[70] h-full w-full max-w-md overflow-y-auto border-l border-sand bg-card shadow-2xl"
        >
          <div className="relative">
            <div className="overflow-hidden">
              <img src={item.image} alt={item.alt} className="aspect-[2/1] w-full object-cover" />
            </div>
            <span
              className={`absolute left-4 top-4 rounded-full px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] ${
                item.category === "Halal Menu" ? "bg-moss text-cream" : "bg-cream/95 text-ink backdrop-blur"
              }`}
            >
              {item.category}
            </span>
            <button
              data-testid="drawer-close-button"
              onClick={onClose}
              aria-label="Close details"
              className="absolute right-4 top-4 grid h-11 w-11 place-items-center rounded-full bg-cream text-ink shadow-lg transition-colors duration-300 hover:bg-moss hover:text-cream"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="px-7 py-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-rust">{item.chip}</p>
            <div className="mt-2 flex items-baseline justify-between gap-4">
              <h3 className="font-display text-3xl font-bold tracking-tight text-ink">{item.name}</h3>
              <span data-testid="drawer-price" className="shrink-0 font-mono text-lg font-semibold text-rust">
                from $16
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-smoke">{item.description}</p>

            <div className="double-rule mt-8 pt-6">
              <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
                <UtensilsCrossed className="h-3.5 w-3.5 text-rust" />
                What's inside
              </p>
              <ul className="mt-4 space-y-2.5">
                {item.ingredients.map((ing) => (
                  <li key={ing} className="flex items-center gap-3 text-sm text-ink">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber" />
                    {ing}
                  </li>
                ))}
              </ul>
            </div>

            <div className="double-rule mt-8 pt-6 pb-4">
              <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">
                <Wheat className="h-3.5 w-3.5 text-rust" />
                Choose your bread
              </p>
              <ul className="mt-4 space-y-3">
                {BREADS.map((b) => (
                  <li key={b.name} className="flex items-baseline text-sm">
                    <span className="font-semibold text-ink">{b.name}</span>
                    <span className="dot-leader" />
                    <span className="font-mono text-sm font-semibold text-rust">${b.price}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.15em] text-smoke/70">
                Price set by your bread choice
              </p>
            </div>
          </div>
        </motion.aside>
      </>
    )}
  </AnimatePresence>
);
